import React from "react";
import S3FileUpload from "@/components/common/inputs/S3FileUpload";
import {
  AcceptedFileTypes,
  SelectedDocument,
} from "@/components/common/inputs/FileUpload";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";

interface FileUploadModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  title: string;
  folderId?: number;
  documentTypeId?: number;
  selectedDocument?: SelectedDocument;
  endpoint?: string;
  acceptedFileTypes?: AcceptedFileTypes[];
  maxFileSize?: number;
  isDriveUpload?: boolean;
  isUpdateId?: number;
}

const FileUploadModal: React.FC<FileUploadModalProps> = ({
  open,
  onClose,
  onSuccess,
  title,
  folderId,
  endpoint,
  isUpdateId,
  documentTypeId,
  selectedDocument,
  acceptedFileTypes = [
    AcceptedFileTypes.PDF,
    AcceptedFileTypes.DOCX,
    AcceptedFileTypes.XLSX,
    AcceptedFileTypes.PNG,
    AcceptedFileTypes.JPG,
  ],
  maxFileSize = 10 * 1000 * 1000, // 10MB default
  isDriveUpload = true,
}) => {
  const handleFileUploadSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-2xl tw-p-6 tw-w-[39%]">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div></div>
          <h2 className="tw-text-lg font-weight-semibold font-primary-color">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="tw-text-gray-500 tw-hover:text-gray-700"
          >
            <img src={CloseIcon} alt="Close Icon" className="tw-w-5 tw-h-5" />
          </button>
        </div>

        <div className="tw-mb-4">
          <S3FileUpload
            label="Upload File"
            folderId={folderId || 0}
            accept={acceptedFileTypes}
            maxFileSize={maxFileSize}
            documentTypeId={documentTypeId}
            id="fileInput-1"
            endpoint={endpoint}
            isUpdate={isUpdateId ? true : false}
            updateId={isUpdateId}
            disableIsNA={true}
            isDriveUpload={isDriveUpload}
            onUploadComplete={handleFileUploadSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default FileUploadModal;
